<template>
  <div>
    <b-button
      size="sm"
      class="edit-icon shadow-none"
      v-b-modal="'modal-1' + index"
    >
      <i class="fa fa-edit"></i>
    </b-button>
    <b-modal :id="'modal-1' + index" title="Edit User Details">
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>

      <b-form @submit.prevent="submitForm">
        <b-form-group id="input-group-1" label="Full Name:" label-for="input-1">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-input
              id="input-1"
              v-model="form.name"
              type="text"
              placeholder="Enter Full Name"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="Email:" label-for="input-2">
          <ValidationProvider rules="email" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.email"
              placeholder="Enter Email"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
          <ValidationProvider rules="phone:10" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.phone"
              placeholder="Enter Phone"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Date of Birth:"
          label-for="input-1"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-input-group>
              <b-form-input
                id="example-input"
                v-model="tempDOB"
                type="text"
                placeholder="DD-MM-YYYY"
                autocomplete="off"
              ></b-form-input>
            </b-input-group>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="User Type:" label-for="input-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-select
              v-model="form._userTypeID"
              :options="options"
              value-field="_id"
              text-field="name"
            ></b-form-select>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <!-- <b-form-group
          id="input-group-2"
          label="Total Credit:"
          label-for="input-2"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.TotalCredits"
              placeholder="Enter Total Credit"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Available Credit:"
          label-for="input-2"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.CurrentCredits"
              placeholder="Enter Available Credit"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group> -->

        <b-form-group
          id="input-group-2"
          label="Member Since:"
          label-for="input-2"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-datepicker
              id="example-datepicker"
              v-model="form.member_since"
              class="mb-2"
            ></b-form-datepicker>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
      </b-form>

      <template #modal-footer="{ close }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="submitForm()">
          Update
        </b-button>
        <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        dob: "",
        _userTypeID: "",
        member_since: "",
        password: "",
        credits: "",
      },
      success: false,
      tempDOB: "",
      options: [],
    };
  },
  props: ["index", "user_types", "data"],
  updated() {
    this.setupdata();
  },
  created() {
    this.setupdata();
  },
  methods: {
    setupdata() {
      this.options = Object.assign({}, this.user_types);
      this.form = Object.assign({}, this.data);
      this.form._id = this.data._id;
      this.form.name = this.data.name;
      this.form.email = this.data.email;
      this.form.TotalCredits = this.data.TotalCredits;
      this.form.CurrentCredits = this.data.CurrentCredits;
      this.form.phone = this.data.phone;
      this.form._userTypeID = this.data._userTypeID._id;
      this.form.credits = this.data.credits;
      this.form.member_since = this.data.member_since
        ? new Date(this.data.member_since)
        : "";
      if (this.form.dob) {
        this.tempDOB = moment(this.form.dob).format("YYYY-MM-DD");
        this.tempDOB = moment(this.tempDOB, "YYYY-MM-DD").format("DD-MM-YYYY");
      }
    },
    submitForm() {
      if (this.tempDOB.length === 10) {
        this.form.dob = moment(this.tempDOB, "DD-MM-YYYY").format("YYYY-MM-DD");

        window.axios.put("users", this.form).then((resp) => {
          if (resp.data.success) {
            this.success = resp.data.message;
            this.form.name = "";
            this.form.email = "";
            this.form.dob = "";
            this.form._userTypeID = "";
            this.form.phone = "";
            this.form.member_since = "";
            this.form.password = "";
            this.tempDOB = "";
            setTimeout(() => {
              this.success = false;
              this.$emit("user-create", resp.data);
            }, 3000);
          }
        });
      } else {
        window.alert("Date of Birth field is invalid!");
      }
    },
  },
};
</script>

<style scoped>
.edit-icon {
  border: none;
  color: #68561d;
  background-color: #fff;
  margin: 0;
  padding-bottom: 2px;
  margin-left: 10px;
}
.fa-edit {
  height: 18px;
  width: 30px;
}
</style>
